<app-select-category
  [_control]="_control"
  [getCategories]="getCategories()"
  [saveCategory]="saveCategory()"
  [updateCategory]="updateCategory()"
  [deleteCategory]="deleteCategory()"
  [categoryNameMinLength]="minNameLength"
  [categoryNameMaxLength]="maxNameLength"
  [reservedCategoryNames]="reservedCategoryNames"
></app-select-category>
